import { createElement } from 'react'
import type { AppNavigationItem } from '@joyful/ui/app'
import {
  DropboxNavBadge,
  PracticeRequestsNavBadge,
  useAppRouteNavigationItems,
} from '@joyful/ui/app'

export function useAppNavigationItems() {
  const navigationItems = useAppRouteNavigationItems({
    activeApp: 'app',
    apps: ['app'],
  })
  const appNavigationItems = navigationItems.map((item) => {
    if (item.key === 'app:requests') {
      return {
        ...item,
        endAdornment: createElement(PracticeRequestsNavBadge),
      }
    }

    if (item.key === 'app:dropbox') {
      return {
        ...item,
        endAdornment: createElement(DropboxNavBadge),
      }
    }

    return item
  })

  return {
    expanded: {
      account: appNavigationItems.filter((item) => {
        return item.key === 'app:members' || item.key === 'app:uncollectible'
      }) satisfies Array<AppNavigationItem>,

      general: appNavigationItems.filter((item) => {
        return item.key === 'app:account' || item.key === 'app:announcements'
      }) satisfies Array<AppNavigationItem>,
    },

    nav: appNavigationItems.filter((item) => {
      return (
        item.key === 'app:dashboard' ||
        item.key === 'app:encounters' ||
        item.key === 'app:patients' ||
        item.key === 'app:projects' ||
        item.key === 'app:requests' ||
        item.key === 'app:dropbox' ||
        item.key === 'app:library' ||
        item.key === 'app:rules' ||
        item.key === 'app:scrubber' ||
        item.key === 'app:providers'
      )
    }) satisfies Array<AppNavigationItem>,
  }
}
